import React from 'react'
import FormItem from './FormItem'
import LabelItem from './LabelItem'
import Input from './Input'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'

type Props = {
  name: string
  label?: string
  placeHolder?: string
  onChange: (val: any, name: string) => void
  isError?: boolean
  value?: any
  type?: string
  isRequired?: boolean
  resProps?: object
  errorMsg?: string
  remark?: string
  prefix?: any
  labelIcon?: any
  specialRequired?: boolean
}

const AppInput = (props: Props): any => {
  const {
    label = '',
    remark = '',
    name,
    isError = false,
    onChange,
    placeHolder = '',
    value,
    type = 'text',
    isRequired = false,
    resProps = {},
    errorMsg = '',
    prefix,
    labelIcon,
    specialRequired = false,
  } = props

  const onChangeData = (val: string) => {
    const value = type === 'number' ? parseFloat(val) : val
    onChange(value, name)
  }

  return (
    <FormItem
      label=""
      status={(isRequired || specialRequired) && isError ? 'error' : ''}
      error={`กรุณาระบุ ${errorMsg || label}`}
    >
      {label && <LabelItem label={isRequired ? `${label}*` : label} />}
      {remark && <Remark>{remark}</Remark>}
      {labelIcon && labelIcon}
      <Input
        type={type}
        placeholder={placeHolder || label}
        name={name}
        value={value}
        onChange={onChangeData}
        resProps={resProps}
        prefix={prefix}
      />
    </FormItem>
  )
}

const Remark = styled.span`
  font-size: 12px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

export default AppInput
